import DataViewerModel from "../../dataViewers/DataViewerModel.js";
import LayoutModel from "../../dataViewers/layout/LayoutModel.js";
export default {
  sort: 1000,
  create(opts) {
    // const tm = TableListGroupDataViewer.create
    if (opts.client === 'GroupScreen') {
      const mdl = LayoutModel.create();
      return LayoutModel.setMain1(mdl, DataViewerModel.create('molten.TableList'));
    }
    return null;
  }
};